import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EquityInstallmentService} from "../../equity-installment.service";
import ProjectInstallmentFundingConditionApprovalLog
  from "../../../interfaces/project-installment-funding-condition-approval-log";

@Component({
    selector: 'app-equity-installment-approval-logs-modal',
    templateUrl: './equity-installment-approval-logs-modal.component.html',
    styleUrls: ['./equity-installment-approval-logs-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquityInstallmentApprovalLogsModalComponent implements OnInit{
    public history:any = {}
    public logs:ProjectInstallmentFundingConditionApprovalLog[] = []
    public loading: Boolean
    constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data:any, private equityService: EquityInstallmentService) {
    }

    ngOnInit() {
      this._fetchHistory()
    }

    private _fetchHistory(){
      this.loading = true;
      this.equityService.fetchApprovalHistoryLogs(this.data.condition_id).subscribe((response:any) => {
        let results = response.data.project_installment_funding_condition_approval_logs;
        this.logs = results
        this.history = this._setLogs(results)
        this.loading = false;
      })
    }

    private _setLogs(logs: ProjectInstallmentFundingConditionApprovalLog[]){
      let obj:any = {}
      for(let i = 0; i < logs.length; i++){
        let typeName = logs[i].projectInstallmentFundingConditionApprovalType.name
        if(obj.hasOwnProperty(typeName)){
          obj[typeName].push(logs[i])
          obj[typeName] = [...obj[typeName]].sort((a:any, b:any) => new Date(b.approval_status_date).getTime() - new Date(a.approval_status_date).getTime())
        } else {
          obj[typeName] = []
          obj[typeName] = [logs[i]]
        }
      }
      return obj
    }


    public close(){
      this.dialogRef.close()
    }

}
